export function unregisterAllServiceWorkers(): void {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(registrations => {
            registrations.forEach(registration => {
                if (registration.active?.scriptURL.includes('firebase-messaging-sw.js')) {
                    return
                }

                void registration.unregister()
            })
        })
    }
}
